<script setup>
import { onUnmounted } from 'vue';
import { useModerationContextInstance } from '/app/composables/moderation';

const props = defineProps({
    context: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        default: '',
    },
    actions: {
        type: Array,
        default: () => ([]),
    },
    inherit: {
        type: Boolean,
        default: false,
    },
});

const {
    abilities,
    mutedUntil,
    contextData,
    parentContext,
    getParentContexts,
    getRootContext,
    getAllChildContexts,
    cleanup
} = useModerationContextInstance(
    () => props.context,
    () => props.id,
    () => props.actions,
    { inherit: () => props.inherit },
);

// Expose context data to template if needed
defineExpose({
    contextData,
    parentContext,
    getParentContexts,
    getRootContext,
    getAllChildContexts,
});

onUnmounted(() => {
    cleanup();
});
</script>

<template>
    <slot 
        :abilities="abilities"
        :mutedUntil="mutedUntil"
        :context="contextData"
        :parent="parentContext"
        :parentContexts="getParentContexts()"
        :rootContext="getRootContext()"
        :childContexts="getAllChildContexts()"
    />
</template>